import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  DoBootstrap,
  Injector,
  NgModule,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { createCustomElement } from '@angular/elements';

// Modules
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '@core/core.module';
import {
  FeatureToggleModule,
  ODataService,
  SecurityModule,
  SecurityService,
} from '@mynexus/mynexus-ui-lib';

// Services
import { AuthenticationService, ConfigurationService } from '@core/service';
import { CHAPPMfeService } from '@core/service/chapp-mfe.service';

// Components
import { MncCHAPPComponent } from './mnc-chapp.component';
import { EmptyComponent } from '@shared/empty/empty.component';

import { environment } from '@env/environment';
import { RouteInterceptor, ShellService, TokenInterceptor } from '@mynexus/mfe-core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorHandler } from '@core/http';
import { HttpUtility } from '@core/http';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';

function loadPermissionsFactory(authenticationService: AuthenticationService, securityService: SecurityService) {
  return () => {
    // Configure permission module
    const permissions = authenticationService.userPermissions;
    securityService.setUserPermissions(permissions.flat());

    // Legacy permissions model force us to set this false to avoid problem with empty permissions users
    securityService.setAllowEmptyPermission(false);
  }
}

@NgModule({
  declarations: [
    MncCHAPPComponent,
    EmptyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    FeatureToggleModule.forRoot(`${environment.hhApiUrl}/api/`),
    SecurityModule.forRoot([]),
  ],
  exports: [
    ...environment.modules,
    MncCHAPPComponent,
  ],
  providers: [
    ConfigurationService,
    HttpUtility,
    HttpErrorHandler,
    DialogService,
    ODataService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadPermissionsFactory,
      deps: [AuthenticationService, SecurityService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RouteInterceptor,
      multi: true
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'MM/dd/YYYY' }
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MncCHAPPModule implements DoBootstrap {
  constructor(
    private injector: Injector,
    private mfeService: CHAPPMfeService,
    shellService: ShellService
  ) {
    shellService.registerMfeService('mnc-chapp', this.mfeService);
  }

  ngDoBootstrap(): void {
    this.registerCustomElement('mnc-chapp', MncCHAPPComponent);
    this.mfeService.resolve(true);
  }

  private registerCustomElement(name: string, component: any) {
    if (customElements.get(name)) return;
    customElements.define(name, createCustomElement<any>(component, { injector: this.injector }));
  }
}
